import { OrderModel } from "../../portfolio-info/types/OrderModel";
import { AssetType } from "../../../shared/types/AssetType";
import { OrderState } from "../../../shared/types/OrderState";
import { TargetPlatform } from "../../../shared/types/TargetPlatform";

export type OrderFilters = {
    orderState: OrderState | null;
    assetType: AssetType | null;
    targetPlatform: TargetPlatform | null;
};

export type OrderFilterAvailability = {
    orderStates: ReadonlySet<OrderState>;
    assetTypes: ReadonlySet<AssetType>;
    targetPlatforms: ReadonlySet<TargetPlatform>;
};

function getAvailability(
    orders: OrderModel[],
    filters: OrderFilters,
): OrderFilterAvailability {
    const orderStates = new Set<OrderState>();
    const assetTypes = new Set<AssetType>();
    const targetPlatforms = new Set<TargetPlatform>();

    orders.forEach(order => {
        if (
            (filters.assetType === null || order.type === filters.assetType) &&
            (filters.targetPlatform === null || order.targetPlatform === filters.targetPlatform)
        ) {
            orderStates.add(order.state);
        }

        if (
            (filters.orderState === null || order.state === filters.orderState) &&
            (filters.targetPlatform === null || order.targetPlatform === filters.targetPlatform)
        ) {
            assetTypes.add(order.type);
        }

        if (
            (filters.orderState === null || order.state === filters.orderState) &&
            (filters.assetType === null || order.type === filters.assetType)
        ) {
            targetPlatforms.add(order.targetPlatform);
        }
    });

    return {
        orderStates,
        assetTypes,
        targetPlatforms,
    };
}

function normalize(
    filters: OrderFilters,
    availability: OrderFilterAvailability,
): OrderFilters {
    return {
        orderState: filters.orderState !== null && availability.orderStates.has(filters.orderState)
            ? filters.orderState
            : null,
        assetType: filters.assetType !== null && availability.assetTypes.has(filters.assetType)
            ? filters.assetType
            : null,
        targetPlatform: filters.targetPlatform !== null && availability.targetPlatforms.has(filters.targetPlatform)
            ? filters.targetPlatform
            : null,
    };
}

function areEqual(left: OrderFilters, right: OrderFilters): boolean {
    return left.orderState === right.orderState &&
        left.assetType === right.assetType &&
        left.targetPlatform === right.targetPlatform;
}

export const orderFilterUtils = {
    getAvailability,
    normalize,
    areEqual,
};
